var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1109"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1107"
  }, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "M 43.22227,54.69421 C 40.447037,50.333238 33.769779,45.915952 26.792379,46.640342 l 0.107383,5.369245 c 4.196045,0.06591 9.607881,3.00094 12.456649,6.872634 z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "m 25.036566,46.790966 0.03766,5.218621 c -1.64843,0.02997 -3.006779,0.21477 -4.510167,0.966464 L 18.631131,48.78804 c 1.610774,-1.038054 3.828201,-1.710714 6.405439,-1.997074 z",
    className: "cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path851",
    d: "m 16.982698,49.790083 1.919684,3.99973 c -1.473177,0.874185 -2.099091,1.07056 -4.080626,2.792007 l -2.563994,-2.49634 c 1.36787,-1.620081 2.92402,-3.108364 4.724936,-4.295397 z",
    className: "cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path853",
    d: "m 11.321293,55.349686 2.464269,2.34364 c -1.091985,1.28745 -2.183969,2.669041 -2.993533,4.088287 L 8.6443316,60.492994 C 9.1600905,58.94801 10.221864,57.064122 11.321293,55.349686 Z",
    className: "cls-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path855",
    d: "m 8.1074074,62.211153 2.0159016,1.017364 c -0.5650584,1.482699 -0.8853531,3.040712 -1.0738499,4.61755 l -1.2642069,-0.0509 C 7.5913881,65.896173 7.6799409,64.016006 8.1074074,62.211152 Z",
    className: "cls-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path857",
    d: "M 8.0620899,69.620711 H 8.925324 c 0.2042524,3.635981 2.686701,8.081568 4.679618,10.73849 -1.816237,-2.393329 -4.7056745,-6.161107 -5.5428521,-10.73849 z",
    className: "cls-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path859",
    d: "m 36.993945,61.029918 c 0,0 -3.725528,-5.407961 -10.703763,-5.512958 -8.354473,-0.170534 -13.876505,6.729703 -13.779994,13.781597 0.09652,7.051894 5.887006,12.904409 13.100958,12.886188 7.213952,-0.01822 13.887508,-5.196175 13.876337,-12.826175 -0.0034,-2.277777 -0.367115,-4.586527 -0.775379,-5.405574 l -4.510166,4.164326 c 0.744386,4.904697 -2.965452,9.198392 -8.525256,9.127717 -5.559805,-0.07068 -8.164931,-4.248103 -8.250474,-7.988332 -0.08554,-3.74023 2.883902,-9.213844 8.858454,-9.085868 1.85167,0.03966 2.852876,0.437958 3.83665,1.07385 l -3.436316,3.436317 -2.362468,-2.255083 -2.684623,10.631105 10.845875,-2.899392 -2.362468,-2.255084 z",
    className: "cls-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path861",
    d: "m 44.789257,57.568518 -3.932105,3.997641 0.06553,17.366798 h 4.390852 l -0.06553,-10.682219 c 0,0 0.617737,-3.58107 3.669966,-3.538896 3.052229,0.04218 3.473359,3.538896 3.473359,3.538896 l 0.196606,10.682219 4.25978,-0.13107 -0.131069,-11.730781 c -0.0062,-3.678588 -3.279813,-6.675967 -6.619045,-6.750114 -3.339232,-0.07414 -5.111736,1.900518 -5.111736,1.900518 z",
    className: "cls-1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path863",
    d: "m 58.944836,68.643949 0.06553,4.259781 h 8.585097 v -4.259781 z",
    className: "cls-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path865",
    d: "m 70.085801,54.816045 0.06553,6.160298 -2.228194,-3e-6 v 3.801034 h 2.162659 v 13.89344 l 4.194245,0.06553 V 64.646308 h 2.55587 v -3.669965 l -2.490334,-0.06553 -0.06553,-6.094762 z",
    className: "cls-1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path867",
    d: "m 78.212152,60.517597 -4e-6,18.28429 h 4.194246 l -0.06553,-9.568123 c -0.04369,-2.446643 1.878673,-4.696681 3.997641,-4.784061 l 3e-6,-3.997641 c -1.288857,-0.02184 -3.560741,1.004871 -4.128712,1.769448 l 10e-7,-1.769447 z",
    className: "cls-1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path869",
    d: "m 100.88729,60.845272 h 4.06318 v 18.022151 h -4.12871 V 76.63923 c 0,0 -2.560264,2.664095 -6.29137,2.686938 -3.731107,0.02285 -8.635982,-3.367962 -8.650633,-9.502588 -0.01466,-6.134626 4.285863,-9.607598 8.650633,-9.633658 4.364769,-0.02605 6.3569,2.883543 6.3569,2.883543 z",
    className: "cls-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path871",
    d: "m 95.447881,64.318633 c -2.601601,0.01874 -4.649645,3.053401 -4.652992,5.439412 -0.0035,2.495022 1.853155,5.745554 4.849597,5.701553 2.903259,-0.04263 4.736164,-3.34694 4.652994,-5.832622 -0.0802,-2.395349 -1.947431,-5.329247 -4.849599,-5.308343 z",
    className: "cls-1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path873",
    d: "m 106.26117,54.816045 h 4.32532 v 13.696833 l 5.76708,-7.667606 h 5.30834 l -6.75011,8.912773 7.33993,9.043842 h -5.76709 l -5.89815,-8.388491 -1e-5,8.454025 h -4.25977 z",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCems);
export default __webpack_public_path__ + "static/media/cems.9183c609a4d4025f4d2f9eff658fd112.svg";
export { ForwardRef as ReactComponent };